@if (isExternal()) {
    <a
        class="btn block"
        [class]="linkClass()"
        [href]="href()"
        [target]="computedTarget()"
        [attr.download]="download()"
        (click)="onLinkClicked()">
        <ng-container *ngTemplateOutlet="linkContent" />
    </a>
} @else {
    <a
        class="btn block"
        [class]="linkClass()"
        [routerLink]="href()"
        [href]="href()"
        [target]="computedTarget()"
        [attr.download]="download()"
        [attr.id]="linkId()"
        (click)="onLinkClicked()">
        <ng-container *ngTemplateOutlet="linkContent" />
    </a>
}

<ng-template #linkContent>
    <div
        class="grow flex items-center gap-2"
        [class.sr-only]="srOnly()"
        [class.min-h-6]="!srOnly()">
        <ng-content />
    </div>
</ng-template>
